import { useState } from "react";
import { CSVAdmin as BaseCSVAdmin } from "../../../utils/csv/csv-validatorAdmin";
export interface CSVAdmin extends BaseCSVAdmin {
  name: string;
  email: string;
  isValid: boolean;
  error?: string;
}
export function useCSVAdminData() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [CSVAdminError, setCSVAdminError] = useState<string | null>(null);
  const [CSVAdminPreviewData, setCSVAdminPreviewData] = useState<CSVAdmin[]>(
    []
  );
  const [invalidData, setInvalidData] = useState<CSVAdmin[]>([]);
  const [fileInputKey, setFileInputKey] = useState(Date.now());
  const isValidEmail = (email: string): boolean => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const isValidName = (name: string): boolean => {
    return name.length >= 3;
  };
  // Function to validate a admin
  function validateAdmin(admin: CSVAdmin): CSVAdmin {
    let isValid = true;
    let error = "";
    if (!isValidName(admin.name)) {
      isValid = false;
      error += "Nome inválido. ";
    }
    if (!isValidEmail(admin.email)) {
      isValid = false;
      error += "Email inválido.";
    }
    return {
      ...admin,
      isValid,
      error: isValid ? undefined : error,
    };
  }
  // Function to handle CSV file upload and validation
  const handleCSVAdminFileUpload = async (file: File) => {
    setSelectedFile(file);
    if (file) {
      try {
        const text = await file.text();
        const rows = text
          .split("\n")
          .map((row: string) =>
            row.split(",").map((cell: string) => cell.trim())
          )
          .filter((row) => row.length === 2 && row[0] && row[1]);
        const validAdmins: CSVAdmin[] = [];
        const invalidAdmins: CSVAdmin[] = [];
        rows.forEach((row) => {
          const name = row[0];
          const email = row[1];
          const admin = validateAdmin({ name, email, isValid: true });
          if (admin.isValid) {
            validAdmins.push(admin);
          } else {
            invalidAdmins.push(admin);
          }
        });
        setCSVAdminError(null);
        setCSVAdminPreviewData(validAdmins);
        setInvalidData(invalidAdmins);
      } catch (error) {
        setCSVAdminError(
          error instanceof Error ? error.message : "Erro ao ler o arquivo."
        );
      }
    }
  };
  return {
    selectedFile,
    setSelectedFile,
    CSVAdminError,
    CSVAdminPreviewData,
    invalidData,
    fileInputKey,
    setFileInputKey,
    validateAdmin,
    handleCSVAdminFileUpload,
    setCSVAdminError,
    setCSVAdminPreviewData,
    setInvalidData,
  };
}
